export function filterModels(data, { dimsValue, material, thickness }) {
  return data
    .map((item) => {
      const { model_prices } = item;

      if (!material || !model_prices.material.includes(material)) {
        return null;
      }

      if (dimsValue) {
        const dimsMatch = model_prices.dims.find((dimObj) => {
          const [min, max] = dimObj.dims.split("-").map(Number);
          return dimsValue >= min && dimsValue <= max;
        });
        if (!dimsMatch) return null;
        item.matchedDimsPrice = dimsMatch.price; // store dims price
      }

      if (material === "Drvo") {
        if (!thickness || !model_prices.drvo.includes(String(thickness))) {
          return null;
        }
        const cmKey = `price_${thickness}cm`;
        if (!(cmKey in model_prices)) {
          return null;
        }
        item.matchedMaterialPrice = model_prices[cmKey];
      }

      if (material === "Staklo") {
        item.matchedMaterialPrice = model_prices.glass_price;
      }

      if (material === "Keramika") {
        item.matchedMaterialPrice = model_prices.ceramic_price;
      }
      return item;
    })
    .filter(Boolean);
}

export function filterByShape(items, shape) {
  return items.filter((item) => item.shape === shape);
}
